import httpUtil from "@/utils/httpUtil";

export const selectAllUnit = params => httpUtil.get("/unit/noPage", params);


